import React, { useEffect, useState } from "react";
import Style from "./style";
import { Link, withRouter } from "react-router-dom";

// img
import SafeIcon from "../../Assets/sidebar/safe-box-door-svgrepo-com.svg";
import HomeIcon from "../../Assets/sidebar/home.svg";
import ProductIcon from "../../Assets/sidebar/Products.svg";
import ThemesIcon from "../../Assets/sidebar/themes.svg";
import UsersIcon from "../../Assets/sidebar/users.svg";
import ZipIcon from "../../Assets/sidebar/Zip.svg";
import VideoIcon from "../../Assets/sidebar/video.svg";
import ContactIcon from "../../Assets/sidebar/contact.svg";
import HelpIcon from "../../Assets/sidebar/help.svg";
import ServicesIcon from "../../Assets/sidebar/services.svg";
import AnnouncementIcon from "../../Assets/sidebar/announcments.svg";
import HolidaysIcon from "../../Assets/sidebar/calendar.svg";
import QuestionsIcon from "../../Assets/sidebar/Questions.svg";
import ServiceRequestIcon from "../../Assets/sidebar/service-request.svg";
import SettingsIcon from "../../Assets/sidebar/settings.svg";
import MobileConfiguration from "../../Assets/sidebar/mobile-configuration.svg";
import SignUpIcon from "../../Assets/sidebar/SignUp-URL.svg";
import Chevron from "../../Assets/down-chevron.svg";
import Tick from "../../Assets/tick.svg";
import Close from "../../Assets/dark-close.svg";

// redux
import { connect } from "react-redux";
import { AddAdmin, EditAdmin, DeleteAdmin, GetModules } from "../../Redux/Actions/AdminAction";
import Modal from "../Modal";

function Admin(props) {
  const [fName, setFName] = useState("");
  const [fNameError, setFNameError] = useState("");
  const [lName, setLName] = useState("");
  const [lNameError, setLNameError] = useState("");
  const [Email, setEmail] = useState("");
  const [EmailError, setEmailError] = useState("");
  const [OpenModal, setModal] = useState(false);
  const [ModulesList, setModulesList] = useState([]);
  const [permission, setPermission] = useState([
    {
      module_id: 1,
      icon: HomeIcon,
      title: "Home",
      status: 0,
    },
    {
      module_id: 2,
      icon: ProductIcon,
      title: "Products",
      status: 0,
    },
    {
      module_id: 3,
      icon: ThemesIcon,
      title: "Themes",
      status: 0,
    },
    {
      module_id: 4,
      icon: UsersIcon,
      title: "Users",
      status: 0,
    },
    {
      module_id: 5,
      icon: ZipIcon,
      title: "Zipcodes",
      status: 0,
    },
    {
      module_id: 6,
      icon: VideoIcon,
      title: "Videos",
      status: 0,
    },
    {
      module_id: 7,
      icon: ContactIcon,
      title: "Contact Us",
      status: 0,
    },
    {
      module_id: 8,
      icon: ServicesIcon,
      title: "Services",
      status: 0,
    },
    {
      module_id: 9,
      icon: QuestionsIcon,
      title: "Questions",
      status: 0,
    },
    {
      module_id: 10,
      icon: ServiceRequestIcon,
      title: "Service Requests",
      status: 0,
    },
    {
      module_id: 11,
      icon: SettingsIcon,
      title: "Settings",
      status: 0,
    },
    {
      module_id: 12,
      icon: HelpIcon,
      title: "Help",
      status: 0,
    },
    {
      module_id: 14,
      icon: SignUpIcon,
      title: "Registration URL",
      status: 0,
    },
    {
      module_id: 15,
      icon: AnnouncementIcon,
      title: "Announcements",
      status: 0,
    },
    {
      module_id: 16,
      icon: HolidaysIcon,
      title: "Holidays",
      status: 0,
    },
    {
      module_id: 19,
      icon: SafeIcon,
      title: "Safe Management",
      status: 0,
    },
    {
      module_id: 20,
      icon: SafeIcon,
      title: "Safe Reconciliation",
      status: 0,
    },
  ]);

  useEffect(() => {
    if (props.location.state && props.location.pathname.split("/")[3] === "edit-admin") {
      setFName("test");
      setLName(props.location.state.last_name);
      setEmail(props.location.state.email);
      setPermission(props.location.state.user_permissions);
    }
  }, []);

  const isModuleSelected = (arr) => {
    let activeModules = arr.filter(function (e) {
      return e.status === 1;
    });
    if (activeModules.length > 0) return true;
    else return false;
  };

  const handleAdd = () => {
    {
      const beta = {
        fName: fName,
        lName: lName,
        email: Email,
        permission: "",
      };
      props.AddAdmin(beta);
      props.history.push({
        pathname: "/dashboard/admin",
        back: "yes",
      });
    }
  };

  useEffect(() => {
    props.GetModules();
  }, []);

  useEffect(() => {
    if (props.modules_data && props.modules_data.data) {
      let temp = [];
      props.modules_data.data.map((module) => {
        let status = 0;
        if (permission.filter((perm) => module.title == perm.title) && permission.filter((perm) => module.title == perm.title)[0]) {
          status = permission.filter((perm) => module.title == perm.title)[0].status;
        }
        temp.push({ id: module.id, title: module.title, status: status });
      });
      setModulesList(temp);
    }
  }, [props.modules_data]);

  const HandleStatus = (id) => {
    const sortCards = [...ModulesList];
    const targetIndex = ModulesList.findIndex((f) => f.id === id);
    sortCards[targetIndex].status = sortCards[targetIndex].status === 0 ? 1 : 0;
    setModulesList(sortCards);
  };

  const handlefName = (e) => {
    if (e.target.value.length < 20 || e.target.value.length === 20) {
      setFName(e.target.value);
      setFNameError("");
    } else {
      setFNameError("First Name can not be more than 20 characters long");
    }
  };

  const handlelName = (e) => {
    if (e.target.value.length < 20 || e.target.value.length === 20) {
      setLName(e.target.value);
      setLNameError("");
    } else {
      setLNameError("Last Name can not be more than 20 characters long");
    }
  };

  const handleModal = (e, type) => {
    e.preventDefault();
    let expression = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
    let regex = new RegExp(expression);
    if (Email.match(regex)) {
      setEmailError("");
      setModal(type);
    } else {
      setEmailError("Invalid Email");
    }
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    if (type === "add_yes") {
      let permissionData = [];
      ModulesList.map((item) => {
        permissionData.push({
          module_id: item.id,
          status: item.status,
        });
      });
      const data = {
        first_name: fName,
        last_name: lName,
        email: Email,
        permissions: permissionData,
      };
      props.AddAdmin(data);
      props.history.push({
        pathname: "/dashboard/admin",
        back: "yes",
        method: "add",
      });
    } else if (type === "add_no") {
      setModal(false);
    } else if (type === "update_yes") {
      let permissionData = [];
      ModulesList.map((item) => {
        permissionData.push({
          module_id: item.id,
          status: item.status,
        });
      });
      const data = {
        id: props.location.state.id,
        first_name: fName,
        last_name: lName,
        email: Email,
        permissions: permissionData,
      };
      props.EditAdmin(data);
      props.history.push({
        pathname: "/dashboard/admin",
        back: "yes",
        method: "update",
      });
    } else if (type === "update_no") {
      setModal(false);
    } else if (type === "delete_yes") {
      props.DeleteAdmin(props.location.state.id);
      props.history.push({
        pathname: "/dashboard/admin",
        back: "yes",
        method: "delete",
      });
    } else if (type === "delete_no") {
      setModal(false);
    }
  };

  return (
    <div className="action-wrap">
      <div className="d-flex justify-content-between align-items-center head-wrap mb-4">
        <Link to="/dashboard/admin" className="d-flex head-left">
          <img src={Chevron} alt="Chevron" />
          <span className="text-nowrap text-white f-20 pl-3 text-uppercase">{props.location.pathname.split("/")[3] === "edit-admin" ? "Edit" : "Add"} admin</span>
        </Link>
      </div>
      <div className="d-flex mt-4">
        <div className="w-50 mr-4">
          <label className="text-grey-6 f-16 d-block mb-1" htmlFor="first_name">
            First Name<span className="text-danger">*</span>
          </label>
          <input value={fName} onChange={(e) => handlefName(e)} type="text" id="fName" placeholder="Enter First Name" className="w-100 input-style" autoComplete="off" />
          {fNameError && <p className="f-12 text-danger">{fNameError}</p>}
        </div>
        <div className="w-50 ml-4">
          <label className="text-grey-6 f-16 d-block mb-1" htmlFor="last_name">
            Last Name<span className="text-danger">*</span>
          </label>
          <input value={lName} onChange={(e) => handlelName(e)} type="text" id="lName" placeholder="Enter Last Name" className="w-100 input-style" autoComplete="off" />
          {lNameError && <p className="f-12 text-danger">{lNameError}</p>}
        </div>
      </div>
      <div className="d-flex w-50 mt-4">
        <div className="w-100 mr-4">
          <label className="text-grey-6 f-16 d-block mb-1" htmlFor="email">
            Email Address<span className="text-danger">*</span>
          </label>
          <input value={Email} onChange={(e) => setEmail(e.target.value)} type="text" id="email" placeholder="Enter Email Address" className="w-100 input-style" autoComplete="off" />
          {EmailError && <p className="f-12 text-danger">{EmailError}</p>}
        </div>
      </div>
      <div className="mt-4">
        <label className="text-grey-6 f-16 d-block mb-1">
          Select Modules<span className="text-danger">*</span>
        </label>
        <div className="d-flex flex-wrap">
          {ModulesList.map((items, index) => {
            return (
              <span key={index} onClick={() => HandleStatus(items.id)} style={items.status === 1 ? { border: "solid" } : { border: "2px solid #3c3c3c" }} className="d-flex form-button-ghost cursor-pointer light-grey-background mr-3 mt-3 rounded pl-3 pr-3 pb-2 pt-2 text-nowrap">
                {props.location.pathname.split("/")[3] === "edit-admin" || props.location.pathname.split("/")[3] === "add-admin" ? (
                  <img
                    src={
                      (items.id === 1 && HomeIcon) ||
                      (items.id === 2 && ProductIcon) ||
                      (items.id === 3 && ThemesIcon) ||
                      (items.id === 4 && UsersIcon) ||
                      (items.id === 5 && ZipIcon) ||
                      (items.id === 6 && VideoIcon) ||
                      (items.id === 7 && ContactIcon) ||
                      (items.id === 8 && ServicesIcon) ||
                      (items.id === 9 && QuestionsIcon) ||
                      (items.id === 10 && ServiceRequestIcon) ||
                      (items.id === 11 && SettingsIcon) ||
                      (items.id === 12 && HelpIcon) ||
                      (items.id === 13 && MobileConfiguration) ||
                      (items.id === 14 && SignUpIcon) ||
                      (items.id === 15 && AnnouncementIcon) ||
                      (items.id === 16 && HolidaysIcon) ||
                      (items.id === 19 && SafeIcon) ||
                      (items.id === 20 && SafeIcon)
                    }
                    alt="HomeIcon"
                    width="24"
                    height="24"
                  />
                ) : (
                  <img src={items.icon} alt={items.title} width="24" height="24" />
                )}
                <span className="text-white pl-2 pr-2">{items.title}</span>
                <img src={items.status === 1 ? Tick : Close} alt="HomeIcon" />
              </span>
            );
          })}
        </div>
      </div>
      <div className="d-flex justify-content-between mt-5">
        {props.location.pathname.split("/")[3] === "edit-admin" && (
          <>
            <button onClick={(e) => handleModal(e, "delete")} className="form-button mr-3">
              Delete
            </button>
            <button disabled={!(fName && lName && Email && isModuleSelected(ModulesList))} onClick={(e) => handleModal(e, "update")} className="form-button ml-3">
              Update
            </button>
          </>
        )}
        {props.location.pathname.split("/")[3] === "add-admin" && (
          <>
            <button
              // disabled={!(fName || lName || Email || isModuleSelected(ModulesList) )}
              onClick={() =>
                props.history.push({
                  pathname: "/dashboard/admin",
                  back: "yes",
                })
              }
              className="form-button mr-3"
            >
              Cancel
            </button>
            <button disabled={!(fName && lName && Email && isModuleSelected(ModulesList))} className="text-green form-button pl-5 pr-5 pt-1 pb-1" onClick={(e) => handleModal(e, "add")}>
              Save
            </button>
          </>
        )}
      </div>
      <Style />
      {OpenModal && <Modal Name={fName + lName} Type={OpenModal} Close={(e, type) => CloseModal(e, type)} />}
    </div>
  );
}

const mapStateToProps = ({ AdminReducer }) => {
  const { loading, add_data, data, modules_data } = AdminReducer;
  return { loading, add_data, data, modules_data };
};

const mapDispatchToProps = {
  AddAdmin,
  EditAdmin,
  DeleteAdmin,
  GetModules,
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Admin));
